/**
 * Frankfurter ECB FX JSON (`latest?from=USD`).
 * In Vite dev the browser hits a same-origin proxy (see `vite.config.ts`) because
 * `api.frankfurter.app` may not send `Access-Control-Allow-Origin` for browser requests.
 */
export function frankfurterLatestFromUsdUrl(): string {
  return import.meta.env.DEV
    ? "/__frankfurter-api/latest?from=USD"
    : "https://api.frankfurter.app/latest?from=USD"
}
